'use strict';

/**
 * Minimal hyperscript-style element builder — avoids innerHTML string
 * interpolation (and the XSS risk of splicing API/user data into markup).
 * `props` accepts normal DOM attrs, `on<Event>` handlers, `class`/`className`
 * and `text` (sets textContent safely).
 */
function h(tag, props = {}, children = []) {
  const el = document.createElement(tag);

  Object.keys(props || {}).forEach((key) => {
    const value = props[key];
    if (value == null || value === false) return;
    if (key === 'class' || key === 'className') {
      el.className = value;
    } else if (key === 'text') {
      el.textContent = value;
    } else if (key === 'html') {
      // Only used for a handful of trusted, hardcoded icon glyphs — never for API/user data.
      el.innerHTML = value;
    } else if (key.startsWith('on') && typeof value === 'function') {
      el.addEventListener(key.slice(2).toLowerCase(), value);
    } else if (key === 'style' && typeof value === 'object') {
      Object.assign(el.style, value);
    } else if (value === true) {
      el.setAttribute(key, '');
    } else {
      el.setAttribute(key, value);
    }
  });

  (Array.isArray(children) ? children : [children]).forEach((child) => {
    if (child == null || child === false) return;
    el.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
  });

  return el;
}

function clear(el) {
  while (el.firstChild) el.removeChild(el.firstChild);
}

module.exports = { h, clear };
